import { useState, useEffect, useCallback } from "react";
import { useStore } from "react-admin";
import { Badge } from "@mui/material";
import { settings } from "app";
import { tenants } from "utils/tenants";
import { employeeRequests } from "api/employeeApi";
import dataProvider from "server/dataProvider";

const TENANTS_WITH_BADGE = [tenants.SU];

// Bumped after a staff request is approved/rejected so the menu badge refetches.
export const PENDING_COUNT_VERSION_KEY = "staffRequests.pendingCountVersion";

const usePendingCount = () => {
  const [count, setCount] = useState(null);
  const [version] = useStore(PENDING_COUNT_VERSION_KEY, 0);

  const fetchCount = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        employeeRequests.getPendingStaffRequestsCount(),
        null,
        "GET",
      );
      setCount(data ?? null);
    } catch (err) {
      console.error(err);
      setCount(null);
    }
  }, []);

  useEffect(() => {
    fetchCount();
    window.addEventListener("focus", fetchCount);
    return () => window.removeEventListener("focus", fetchCount);
  }, [fetchCount, version]);

  return count;
};

const PendingRequestsBadge = ({ label }) => {
  const count = usePendingCount();

  return (
    <Badge
      badgeContent={count}
      color="error"
      max={99}
      showZero
      invisible={count == null}
      sx={{
        "& .MuiBadge-badge": {
          position: "static",
          transform: "none",
          ml: 1,
        },
      }}
    >
      {label}
    </Badge>
  );
};

const PendingRequestsTitle = ({ label }) =>
  TENANTS_WITH_BADGE.includes(settings.tenant) ? <PendingRequestsBadge label={label} /> : label;

export default PendingRequestsTitle;
